export default {
  zqorder: {
    placeholderList: {
      placeholderinput: 'Product Name/Product ID/Order No.',
      placeholderSelect: 'Select'
    },
    navList: {
      navitem1: 'All Orders',
      navitem2: 'Pending Reconciliation',
      navitem3: 'Pending Settlement',
      navitem4: 'Settled',
      navitem5: 'Cancelled',
      navitem6: 'Overdue'
    },
    table: {
      step1: 'Reconciliation Period',
      step2: 'Reconciliation Date',
      step3: 'Payment Due Date',
      step4: 'Overdue',
      step5: 'Late Fee',
      step6: 'Statement Type',
      step7: 'Settlement Status',
      step8: 'Action',
      step9: 'Statement No.',
      step10: 'Merchant Name',
      step11: 'Statement Amount',
      step12: 'Reconciliation Date',
      step13:'No data available at the moment',
      step14:'Settlement statements for the past three months',
      step15:'Settlement statement from three months ago'
    },
    msgState: {
      msg1: 'Due in ',
      msg2: ' natural days after reconciliation',
      msg3: 'Natural Day',
      msg4: 'System Generated',
      msg5: 'Early Settlement',
      msg6:'Day',
    },
    btnState: {
      btn1: 'Reconcile Now',
      btn2: 'Cancel Early Settlement',
      btn3: 'Invoice',
      btn4: 'Verify Invoice',
      btn5: 'Pay Now',
      btn6: 'Statement Details'
    },
    confirmState: {
      confirm1: 'Notification',
      confirm2: 'Confirm',
      confirm3: 'Cancel',
      confirm4: 'Cancelled',
      confirm5: 'Require merchant invoice?',
      confirm6: 'Request Invoice',
      confirm7: 'No Invoice Needed'
    }
  }
}